// Social media account links, defined once and reused across the nav and footer.
export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/hamakom_hotel/',
  facebook: 'https://www.facebook.com/hamakom.suites.netua/?locale=he_IL',
  tiktok: 'https://www.tiktok.com/@hamakom.hotel',
};
